import qs from 'query-string';
import { get } from '../baseApi';

export const AccountStatusApi = {
    fetch: (query) => get(`/admin/accounts/status?${qs.stringify(query)}`),
};
